import React, { Component } from 'react';
import { Zoom, Fade, Slide } from "react-reveal";

export default class Footer extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">
            {
              resumeData.socialLinks && resumeData.socialLinks.map((item)=>{
                return(
                  <Fade delay={500}>
                  <li key={item.url}>
                    <a href={item.url}>
                    <i className={item.className} />
                    </a>
                  </li>
                  </Fade>
                )
              })
            }
          </ul>
          
        </div>
        <Fade bottom><div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open" /></a></div></Fade>
      </div>
    </footer>
    );
  }
}